import styled from 'vue-styled-components';
import COLORS from '@design/colors.js';
import { square } from '@styles/common.styled';

import { FLEX_COLUMN_DIV } from '@styles/common.styled.component';

import WarningIcon from '@svgIcons/warning.svg';

export const ErrorBox = {
    name: 'ErrorBox',
    functional: true,
    props: {
        errorText: String,
    },
    render(h, data) {
        return (
            <ErrorMessage class="error-box">
                <WarningIcon v-view-box /> {data.props.errorText}
            </ErrorMessage>
        );
    },
};

export default {
    name: 'ErrorDialogContent',
    functional: true,
    render(h, { data }) {
        const { mainText, errorText } = data.attrs;

        return (
            <Wrapper>
                <TextWrap>{mainText}</TextWrap>
                {errorText && <ErrorBox errorText={errorText} />}
            </Wrapper>
        );
    },
};

const Wrapper = FLEX_COLUMN_DIV;

export const TextWrap = styled.div`
    white-space: pre-wrap;
    font-size: 16px;
    font-weight: normal;
    color: ${COLORS['gray-100']};
    margin-bottom: 13px;
`;

export const ErrorMessage = styled.div`
    font-size: 16px;
    color: ${COLORS['red-60']};
    max-width: 480px;

    svg {
        fill: ${COLORS['red-60']};
        float: left;
        margin-top: 4px;
        ${square(16)};
        margin-right: 4px;
        flex-shrink: 0;
    }
`;
